{
    // Instantiate TabPanelWidget
    Tabpanelwidget.autoinstall();
}